import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import WishSwapStepBuy_1 from "../wishSteps/swap/step_1";
import WishSwapStepBuy_2 from "../wishSteps/swap/step_2";
import WishSwapStepBuy_3 from "../wishSteps/swap/step_3";
import WishSwapStepBuy_4 from "../wishSteps/swap/step_4";
import WishSwapStepBuy_5 from "../wishSteps/swap/step_5";
import WishSwapStepBuy_6 from "../wishSteps/swap/step_6";
import WishSwapStepBuy_7 from "../wishSteps/swap/step_7";

const getWishSwapSteps = (
  data: IFillDataWizardBuy,
  dataFeatures: Partial<IFillDataWizardBuy>,
  dataFormEstimate: Partial<IFillDataWizardBuy>,
  handleChangeDataObject: (data: Partial<IFillDataWizardBuy>) => void,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_estimate: boolean;
    isNextStep_dataFeatures: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeView: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
  }
) => {
  const {
    isNextStep_estimate,
    isNextStep_dataFeatures,
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeView,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
  } = disabledAndPrev;

  return [
    <WishSwapStepBuy_1
      onChangePrice={handleChangeDataNumber}
      onChange={handleChangeDataObject}
      isNextStepDisabled={isNextStep_estimate}
      onReset={onReset}
      dataFormEstimate={dataFormEstimate}
    />,
    <WishSwapStepBuy_2
      onChange={handleChangeDataObject}
      data={dataFeatures}
      isNextStepDisabled={isNextStep_dataFeatures}
      onReset={onReset}
    />,
    <WishSwapStepBuy_3
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <WishSwapStepBuy_4
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <WishSwapStepBuy_5
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <WishSwapStepBuy_6
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <WishSwapStepBuy_7 data={data} />,
  ];
};

export default getWishSwapSteps;
